import { create } from "zustand";
import { persist } from "zustand/middleware";

type Theme = "light" | "dark";

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: "dark",
      setTheme: (theme) => {
        set({ theme });
        applyTheme(theme);
      },
      toggleTheme: () => {
        const newTheme = get().theme === "dark" ? "light" : "dark";
        set({ theme: newTheme });
        applyTheme(newTheme);
      },
    }),
    {
      name: "theme-storage",
    }
  )
);

export function applyTheme(theme: Theme) {
  const root = window.document.documentElement;
  
  // Добавляем класс для мгновенного переключения (отключает все transitions)
  root.classList.add("theme-transitioning");
  
  // Применяем тему синхронно
  root.classList.remove("light", "dark");
  root.classList.add(theme);
  
  // Принудительно обновляем стили для мгновенного применения
  void root.offsetHeight;
  
  // Убираем класс после применения темы (в следующем кадре)
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      root.classList.remove("theme-transitioning");
    });
  });
}

// Initialize theme on load
if (typeof window !== "undefined") {
  const stored = localStorage.getItem("theme-storage");
  if (stored) {
    try {
      const { state } = JSON.parse(stored);
      applyTheme(state.theme || "dark");
    } catch {
      applyTheme("dark");
    }
  } else {
    applyTheme("dark");
  }
}
